import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BatchService } from 'projects/services/src/app/API/batch.service';
import { FileUpload } from 'projects/common/src/app/file-upload/file-upload.component';
import { DTable, Pagination } from 'projects/common/src/app/types';
declare var toastr: any;
declare const swal;
@Component({
	selector: 'app-view-candidate-details-info',
	templateUrl: './view-candidate-details-info.component.html',
	styleUrls: ['./view-candidate-details-info.component.css']
})
export class ViewCandidateDetailsInfoComponent implements OnInit {
	@Input()
	candidateId: any;
	profileImage: any;
	candidateDetails: any;
	default_image = 'assets/images/Dummy_Image_Man.jpg';

	educationDetailsArray: any = [];

	preferencesList = new DTable({
		withoutSerialNumber: false,
		headers: {
			jobrole: 'Job Role',
			qpCode: 'QP Code',
			sectorName: 'Sector Name',
			sudSectorName: 'Sub-Sector Name'
			// state: 'State',
			// distict: 'District',
		},
		pagination: new Pagination()
	});
	ExperienceList = new DTable({
		withoutSerialNumber: false,
		headers: {
			jobrole: 'Job Role',
			sectorName: 'Sector Name',
			experienceInMonths: 'Experience In Months',
			experienceInYear: 'Experience In Years',
			// state: 'State',
			// distict: 'District',
		},
		pagination: new Pagination()
	});
	canExpDetails: any = [];
	updateProfilePhotoForm: FormGroup
	profilePictureUpload: FileUpload = {
		type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: 'Choose File', required: true,
		defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg, JPG, PNG, JPEG)', fieldName: 'Profile Picture'
	};
	batchId: any;

	constructor(
		private batchService: BatchService,
		private location: Location,
		private fileService: FileService,
		private router: Router,
		private formBuilder: FormBuilder,
		private ac:ActivatedRoute

	) {
		this.updateProfilePhotoForm = this.formBuilder.group({
			profilePicture:['',[Validators.required]]
		})
		this.batchId=this.ac.snapshot.params.batchId || ''
		console.log(this.ac.snapshot)

		// this.getCandidateDetails();
	}

	ngOnInit() {

		this.getCandidateDetails();
	}

	getCandidateDetails() {
		this.batchService.candidateDetails(this.candidateId).subscribe(res => {
			this.candidateDetails = res;
			const experienceListArray = [];
			const preferencesListArray = [];
			if (this.candidateDetails && this.candidateDetails.experienceDetails && this.candidateDetails.experienceDetails.length  > 0) {
				this.canExpDetails = this.candidateDetails.experienceDetails;
			}
			for (let expindex = 0; expindex < this.candidateDetails.experienceDetails.length; expindex++) {
				experienceListArray.push({
					'jobRole': this.candidateDetails.experienceDetails[expindex] && this.candidateDetails.experienceDetails[expindex].jobRole,
					'sectorName': this.candidateDetails.experienceDetails[expindex] && this.candidateDetails.experienceDetails[expindex].sector,
					'experienceInMonths': this.candidateDetails.experienceDetails[expindex] && this.candidateDetails.experienceDetails[expindex].monthOfExperience,
					'experienceInYear': this.candidateDetails.experienceDetails[expindex] && this.candidateDetails.experienceDetails[expindex].yearOfExperience,
				})
			}

			for (
				let i = 0;
				i < this.candidateDetails.coursePreferences.length;
				i++
			) {
				preferencesListArray.push({
					jobrole: this.candidateDetails.coursePreferences[i].jobRole,
					sectorName: this.candidateDetails.coursePreferences[i]
						.sector,
					sudSectorName: this.candidateDetails.coursePreferences[i]
						.subSector,
					qpCode: this.candidateDetails.coursePreferences[i].qpCode
				});
			}

			this.formatEducationArray(this.candidateDetails)
			this.preferencesList.data = preferencesListArray;
			this.ExperienceList.data = experienceListArray;

			if (this.candidateDetails.personalDetails.profilePicture) {
				this.getImageUrl(this.candidateDetails.personalDetails.profilePicture);
			}
		});
	}


	formatEducationArray(educationData) {
		const educationListArray = [];
			for (
				let i = 0;
				i < educationData.educationalDetails.length;
				i++
			) {
				educationListArray.push({
					education: educationData.educationalDetails[i]
						.education,
					specialization: educationData.educationalDetails[i]
						.specialization,
					PassingYear: educationData.educationalDetails[i] && educationData.educationalDetails[i].passingYear,
					document:
						educationData.educationalDetails[i].document &&
						Helpers.deriveNameFromS3Url(
							educationData.educationalDetails[i].document
						),
					documentUrl: educationData.educationalDetails[i]
						.document
				});
			}
			// return educationListArray;
			this.educationDetailsArray = educationListArray;
	}

	onBack() {
		this.location.back();
	}

	downloadPdf(url) {
		this.fileService.downloadAttachedFile(url);
	}

	getImageUrl(s3Url) {
		this.fileService.getImageURL(s3Url).subscribe(res => {
			this.profileImage = res;
			console.log(res, 'resURL');
		});
	}

	viewCandidateDetails(candidateID) {
		const url = `trainingpartner/view-candidate-details/${candidateID}`;
		this.router.navigate([url]);
	}

	updateProfilePhoto() {
		this.updateProfilePhotoForm.reset();
		Helpers.openModal('profilePhoto');
	}

	submitProfilePhoto() {
		if (this.updateProfilePhotoForm.invalid) {
			Helpers.markFormGroupTouched(this.updateProfilePhotoForm);
			return;
		}
		if (this.updateProfilePhotoForm.valid) {
			swal({
				title: 'Are you sure want to update Profile Photo for selected candidate',
				type: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Yes'
			}).then(result => {
				if (result.value) {
					const mapPayLoad = this.updateProfilePhotoForm.value;
					mapPayLoad['candidateId'] = this.candidateId;
					mapPayLoad['batchId'] = Number(this.batchId);
					this.batchService.updateCandidateProfilePhoto( mapPayLoad).subscribe(res => {
						toastr.success('Data Updated Successfully!!')
						Helpers.closeModal('updateProfilePhoto')
						this.getCandidateDetails()
					})
				}
			});
		} else {
			toastr.error('Please fill all mandatory details')
		}
	}

	fileUploaded(event, uploaded: string) {
		this.updateProfilePhotoForm.get('profilePicture').setValue(event.url);
		toastr.success(`${event.name} file uploaded successfully` );
	}

	onFileUploadCancel(event, uploaded: string) {
		this.updateProfilePhotoForm.get('profilePicture').setValue('');
	}

	closeCanProfilePhotoModel() {
		Helpers.closeModal('profilePhoto');
	}
}
